var __jsx = React.createElement;
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { isAllOffersProductWithOffer } from '@uno/common-cms';
import { ItemInvalid, ItemSubTitle, ItemTitle, MinusIcon, NumberInputContainer, PlusIcon, SelectedItemAndRetailerContainer } from './SelectedItemAndRetailer.style';

var SelectedItemAndRetailer = function SelectedItemAndRetailer(_ref) {
  var _selectedProduct$offe, _selectedProduct$offe2;

  var selectedProduct = _ref.selectedProduct,
      retailerNumber = _ref.retailerNumber,
      setRetailerNumber = _ref.setRetailerNumber;
  var intl = useIntl();
  var maxRetailerNumber = 10;
  return __jsx(SelectedItemAndRetailerContainer, null, __jsx("div", null, __jsx(ItemTitle, null, selectedProduct.name), isAllOffersProductWithOffer(selectedProduct) ? __jsx(ItemSubTitle, null, (_selectedProduct$offe = selectedProduct.offers[0]) === null || _selectedProduct$offe === void 0 ? void 0 : _selectedProduct$offe.storeName, " - ", (_selectedProduct$offe2 = selectedProduct.offers[0]) === null || _selectedProduct$offe2 === void 0 ? void 0 : _selectedProduct$offe2.price, "\u20AC") : __jsx(FormattedMessage, {
    id: "affiliation-table-modal.no-offer",
    tagName: ItemInvalid
  })), __jsx("div", null, __jsx(FormattedMessage, {
    id: "affiliation-table-modal.retailer"
  }), __jsx(NumberInputContainer, null, __jsx(MinusIcon, {
    "aria-label": intl.formatMessage({
      id: 'affiliation-table-modal.labels.minus'
    }),
    onClick: function onClick() {
      if (retailerNumber > 1) {
        setRetailerNumber(retailerNumber - 1);
      }
    }
  }), __jsx("span", null, retailerNumber), __jsx(PlusIcon, {
    "aria-label": intl.formatMessage({
      id: 'affiliation-table-modal.labels.plus'
    }),
    onClick: function onClick() {
      if (retailerNumber < maxRetailerNumber) {
        setRetailerNumber(retailerNumber + 1);
      }
    }
  }))));
};

export default SelectedItemAndRetailer;